export default __webpack_public_path__ + "static/media/store.b14540c6.jpeg";